import { Col, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import Select from "react-select";
import Cktest from "../../cktetst/Cktest";
import ImageUploading from "react-images-uploading";
import { DeleteOutlined } from "@ant-design/icons";
import { Image } from "react-bootstrap";
import { URL } from "../../../Redux/common/url";
import { Link, useNavigate, useParams } from "react-router-dom";
import { allapiAction } from "../../../Redux/common/action";
import Api from "../../../Redux/common/api";
import SvgIcon from "../../const/SvgIcon";

function UpdateProductCom() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  // States
  const [rows, setRows] = useState([]);
  const [ferows, setfeRows] = useState([{ name: "", value: "" }]);
  const [aboutPage, setaboutPage] = useState("");
  const [images, setImages] = useState([]);
  const [imagesmulti, setImagesMulti] = useState([]);
  const [productData, setproductData] = useState({});
  const [btndis, setbtndis] = useState(false);

  // Dropdown states
  const [selectedOption, setSelectedOption] = useState(null);
  const [subList, setsubList] = useState([]);
  const [subList4, setsubList4] = useState([]);
  const [selectedOption4, setSelectedOption4] = useState(null);
  const [maincateList, setmaincateList] = useState([]);
  const [selectedOptionPr, setSelectedOptionPr] = useState(null);
  const [selectedOptionbrand, setSelectedOptionbrand] = useState(null);
  const [branList, setbrandList] = useState([]);

  const maxNumber = 3;

  // Redux Selectors
  const get_sub_sub_category_list = useSelector(
    (state) => state.allapi.get_sub_sub_category_list || [],
  );
  const get_main_all_category = useSelector(
    (state) => state?.allapi?.get_main_all_category || [],
  );
  const get_sub_sub_category = useSelector(
    (state) => state?.allapi?.get_sub_sub_all_category || [],
  );
  const get_product_details = useSelector(
    (state) => state.allapi.get_product_details || {},
  );
  const grt_all_brand = useSelector(
    (state) => state.allapi.grt_all_brand || [],
  );

  // API Calls on Mount
  useEffect(() => {
    dispatch(allapiAction.getsubsubcate({}));
    dispatch(allapiAction.getbrandAllListseller({}));
    dispatch(allapiAction.productDetails(id));
    dispatch(allapiAction.getsubcateAllList({}));
    dispatch(allapiAction.getcateAllList({}));
  }, [id, dispatch]);

  // Map incoming Product Data to Form
  useEffect(() => {
    if (get_product_details && Object.keys(get_product_details).length > 0) {
      setproductData(get_product_details);

      if (get_product_details?.description) {
        setaboutPage(get_product_details?.description);
      }

      if (get_product_details?.featureImage) {
        setImages([
          { data_url: URL.API_BASE_URL + get_product_details.featureImage },
        ]);
      }

      // Handle Features Parsing safely
      if (get_product_details?.features) {
        try {
          const parsedFeatures =
            typeof get_product_details.features === "string"
              ? JSON.parse(get_product_details.features)
              : get_product_details.features;
          setfeRows(
            parsedFeatures?.length > 0
              ? parsedFeatures
              : [{ name: "", value: "" }],
          );
        } catch (e) {
          console.error("Error parsing features", e);
        }
      }

      // Handle Variations & Variation Images
      if (get_product_details?.subcolor?.length > 0) {
        const selectCate = subList.find(
          (edata) => edata?._id == get_product_details?.categoryId,
        );
        setSelectedOption(selectCate);

        const finalData = get_product_details?.subcolor?.map((data) => {
          const dataImg =
            data?.images?.map((data2) => ({
              data_url: URL.API_BASE_URL + data2.img,
              old_img: data2.img, // store original path to send back
            })) || [];

          return {
            ...data,
            images: dataImg,
            sizeProduct: data.sizeProduct ||
              data.productsize || [
                {
                  size: "",
                  sizetype: "",
                  price: "",
                  stock: "",
                  afterdiscountprice: "",
                },
              ],
          };
        });
        setRows(finalData);
      }
    }
  }, [get_product_details, subList]);

  // Dropdown effect mappings (Main Category)
  useEffect(() => {
    const dropList = get_main_all_category?.map((data) => {
      data.value = data?._id;
      data.label = data?.name;
      return data;
    });
    setmaincateList(dropList);
  }, [get_main_all_category]);

  // Categories Pre-fill setup
  useEffect(() => {
    if (maincateList?.length > 0 && get_product_details?.categoryDetails) {
      const getfind = maincateList.find(
        (edata) =>
          edata?._id == get_product_details?.categoryDetails[0]?.parentId,
      );
      if (getfind !== undefined) {
        setSelectedOptionPr(getfind);
        const filterdata = get_sub_sub_category?.filter(
          (data) => data?.parentId == getfind?._id,
        );
        const dropList = filterdata?.map((data) => {
          data.value = data?._id;
          data.label = data?.name;
          return data;
        });

        const getfindv = dropList.find(
          (edata) =>
            edata?._id == get_product_details?.categoryDetails[0]?.subparentId,
        );
        setsubList4(dropList);
        setSelectedOption4(getfindv);
      }
    }
  }, [maincateList, get_product_details, get_sub_sub_category]);

  // Brand Pre-fill setup
  useEffect(() => {
    const dropList = grt_all_brand?.map((data) => {
      data.value = data?._id;
      data.label = data?.name;
      return data;
    });
    setbrandList(dropList);
  }, [grt_all_brand]);

  useEffect(() => {
    if (branList?.length > 0 && get_product_details?.brandId) {
      const getfind = branList.find(
        (edata) => edata?._id == get_product_details?.brandId,
      );
      if (getfind !== undefined) {
        setSelectedOptionbrand(getfind);
      }
    }
  }, [branList, get_product_details]);

  useEffect(() => {
    const dropList = get_sub_sub_category_list?.map((data) => {
      data.value = data?._id;
      data.label = data?.name;
      return data;
    });
    setsubList(dropList);
  }, [get_sub_sub_category_list]);

  // Handlers
  const hendletotest = (e) => {
    setSelectedOptionPr(e);
    const filterdata = get_sub_sub_category?.filter(
      (data) => data?.parentId == e?._id,
    );
    const dropList = filterdata?.map((data) => {
      data.value = data?._id;
      data.label = data?.name;
      return data;
    });
    setsubList4(dropList);
    setSelectedOption4(null);
    setSelectedOption(null);
  };

  const hendleChangerole = (e) => {
    const { name, value } = e.target;
    setproductData({ ...productData, [name]: value });
  };

  const onChange = (imageList) => setImages(imageList);
  const onChangemulti = (imageList) => setImagesMulti(imageList);

  const HendleImgFVer = (imageList, rowIndex) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[rowIndex].images = imageList; // Correctly replace with new image list
      return updatedRows;
    });
  };

  const onRemoveImage = (variantIndex, imageIndex) => {
    setRows((prevVariants) => {
      const updatedVariants = [...prevVariants];
      updatedVariants[variantIndex].images.splice(imageIndex, 1);
      return updatedVariants;
    });
  };

  const addSizeProduct = (index) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index].sizeProduct.push({
        size: "",
        sizetype: "",
        price: "",
        stock: "",
        afterdiscountprice: "",
      });
      return updatedRows;
    });
  };

  const removeSizeProduct = (rowIndex, sizeIndex) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[rowIndex].sizeProduct.splice(sizeIndex, 1);
      return updatedRows;
    });
  };

  const removeColorProduct = (index) =>
    setRows((prevRows) => prevRows.filter((row, i) => i !== index));
  const removeFeatures = (index) =>
    setfeRows((prevRows) => prevRows.filter((row, i) => i !== index));

  const handleSizeChange = (rowIndex, sizeIndex, field, value) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[rowIndex].sizeProduct[sizeIndex][field] = value;
      return updatedRows;
    });
  };

  const handleColorChange = (rowIndex, sizeIndex, field, value) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[rowIndex][field] = value;
      return updatedRows;
    });
  };

  const handlefrturechChange = (rowIndex, sizeIndex, field, value) => {
    setfeRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[rowIndex][field] = value;
      return updatedRows;
    });
  };

  // CkEditor Adapter
  const API_URl = URL.API_BASE_URL;
  const UPLOAD_ENDPOINT = "publicApi/productcon";

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("upload", file);
            fetch(`${API_URl}/${UPLOAD_ENDPOINT}`, {
              method: "post",
              body: body,
            })
              .then((res) => res.json())
              .then((res) => resolve({ default: `${res.url}` }))
              .catch((err) => reject(err));
          });
        });
      },
    };
  }
  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) =>
      uploadAdapter(loader);
  }

  const colorList = [
    { name: "INDIANRED", hex: "#CD5C5C" },
    { name: "LIGHTCORAL", hex: "#F08080" },
    { name: "SALMON", hex: "#FA8072" },
    { name: "CRIMSON", hex: "#DC143C" },
    { name: "RED", hex: "#FF0000" },
    { name: "DARKRED", hex: "#8B0000" },
    { name: "PINK", hex: "#FFC0CB" },
    { name: "HOTPINK", hex: "#FF69B4" },
    { name: "DEEPPINK", hex: "#FF1493" },
    { name: "CORAL", hex: "#FF7F50" },
    { name: "TOMATO", hex: "#FF6347" },
    { name: "ORANGERED", hex: "#FF4500" },
    { name: "ORANGE", hex: "#FFA500" },
    { name: "GOLD", hex: "#FFD700" },
    { name: "YELLOW", hex: "#FFFF00" },
    { name: "LAVENDER", hex: "#E6E6FA" },
    { name: "PLUM", hex: "#DDA0DD" },
    { name: "VIOLET", hex: "#EE82EE" },
    { name: "PURPLE", hex: "#800080" },
    { name: "INDIGO", hex: "#4B0082" },
    { name: "GREENYELLOW", hex: "#ADFF2F" },
    { name: "LIME", hex: "#00FF00" },
    { name: "LIMEGREEN", hex: "#32CD32" },
    { name: "GREEN", hex: "#008000" },
    { name: "DARKGREEN", hex: "#006400" },
    { name: "TEAL", hex: "#008080" },
    { name: "CYAN", hex: "#00FFFF" },
    { name: "SKYBLUE", hex: "#87CEEB" },
    { name: "BLUE", hex: "#0000FF" },
    { name: "NAVY", hex: "#00008B" },
    { name: "WHEAT", hex: "#F5DEB3" },
    { name: "BROWN", hex: "#A52A2A" },
    { name: "MAROON", hex: "#800000" },
    { name: "WHITE", hex: "#FFFFFF" },
    { name: "SILVER", hex: "#C0C0C0" },
    { name: "GRAY", hex: "#808080" },
    { name: "BLACK", hex: "#000000" },
  ];

  const hendleTosubmit = async () => {
    const data = new FormData();

    if (images?.length == 0) {
      toast.error("please select feature Image");
      return;
    } else if (!productData?.title) {
      toast.error("please enter product name");
      return;
    } else if (!selectedOption) {
      toast.error("please select category ");
      return;
    }

    setbtndis(true);

    data.append("productId", productData?._id);
    data.append("title", productData?.title);
    data.append("price", productData?.price);
    data.append("seo_title", productData?.seo_title);
    data.append("productType", productData?.productType);
    data.append("sku", productData?.sku);
    data.append("seo_description", productData?.seo_description);

    // Add missing features & video from Create API
    data.append("features", JSON.stringify(ferows));
    data.append("video_type", productData?.video_type || "");
    data.append("video_link", productData?.video_link || "");
    data.append("districtpv", productData?.districtpv || 0);
    data.append("pincodepv", productData?.pincodepv || 0);

    data.append("categoryId", selectedOption?._id);
    if (selectedOptionPr?._id)
      data.append("categorymainId", selectedOptionPr?._id);
    if (selectedOptionbrand?._id)
      data.append("brandId", selectedOptionbrand?._id);
    if (selectedOption4?._id)
      data.append("categorysubId", selectedOption4?._id);

    data.append("gst", productData?.gst);
    data.append("delivery_charges", productData?.delivery_charges);
    data.append("description", aboutPage);

    if (images[0]?.file) {
      data.append("featureImage", images[0]?.file);
    }

    try {
      const token = await localStorage.getItem("access_token_vendor");
      const config = { headers: { Authorization: "Bearer " + token } };

      const response = await Api.post(`${URL.updateProduct}`, data, config);

      // Submit Variations
      for (const row of rows) {
        const data2 = new FormData();
        data2.append("productId", productData?._id);
        data2.append("productType", productData?.productType);
        if (selectedOptionPr?._id)
          data2.append("categorymainId", selectedOptionPr?._id);
        data2.append("color", row?.color);
        if (row?._id) data2.append("_id", row?._id);

        data2.append("gst", productData?.gst);
        data2.append("delivery_charges", productData?.delivery_charges);
        data2.append("districtpv", productData?.districtpv || 0);
        data2.append("pincodepv", productData?.pincodepv || 0);

        const psize = row?.sizeProduct?.map((data) => {
          data.productcolorId = data.productcolorId
            ? data.productcolorId
            : row?._id;
          return data;
        });
        data2.append("sizeProduct", JSON.stringify(psize));

        row?.images?.forEach((file) => {
          if (file?.file) {
            data2.append("images", file?.file);
          } else if (file?.old_img) {
            // Use securely saved original path
            data2.append("oldimages", file.old_img);
          } else if (file?.data_url) {
            const relativeUrl = file?.data_url.replace(URL.API_BASE_URL, "");
            data2.append("oldimages", relativeUrl);
          }
        });

        await Api.post(`${URL.updateProductvariations}`, data2, config);
      }
      setbtndis(false);
      navigate("/seller/product");
    } catch (error) {
      setbtndis(false);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className=" code-box">
      <div className="flex">
        <div>
          <div className="flex gap10">
            <div>
              <Tooltip title="Back">
                <Link to={"/seller/product"}>
                  <Image
                    src={SvgIcon?.LeftArrow?.src}
                    alt="Left Arrow"
                    width={20}
                    height={20}
                    style={{ verticalAlign: "middle" }}
                  />
                </Link>
              </Tooltip>
            </div>
            <div>
              <div className="opacity-8 fw-bold fs-16">Update Listing</div>
            </div>
          </div>
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5 ml-5"></Col>
      </div>

      <div className="paddcopm">
        <div className="container pdcon">
          <div className="prosection">
            <div className="row">
              <div className="col-12">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Feature Image</span>
                  </label>
                  <ImageUploading
                    value={images}
                    onChange={onChange}
                    maxNumber={maxNumber}
                    dataURLKey="data_url"
                    acceptType={["png", "jpeg", "jpg", "webp"]}
                  >
                    {({
                      imageList,
                      onImageUpload,
                      onImageRemoveAll,
                      onImageUpdate,
                      onImageRemove,
                      isDragging,
                      dragProps,
                    }) => (
                      <div className="upload__image-wrapper">
                        <button
                          style={isDragging ? { color: "red" } : {}}
                          onClick={onImageUpload}
                          {...dragProps}
                          className="btn btn-success"
                        >
                          Choose feature image
                        </button>
                        &nbsp;
                        {imageList.map((image, index) => (
                          <div key={index} className="image-item">
                            <img src={image.data_url} alt="" width="100" />
                            <div className="image-item__btn-wrapper">
                              <button
                                className="btn btn-secondary"
                                onClick={() => onImageUpdate(index)}
                              >
                                {" "}
                                Update{" "}
                              </button>
                              <button
                                className="btn btn-secondary"
                                onClick={() => onImageRemove(index)}
                              >
                                {" "}
                                Remove{" "}
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </ImageUploading>
                </div>
              </div>
              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Product Name</span>
                  </label>
                  <input
                    placeholder="Enter a product name"
                    name="title"
                    value={productData?.title || ""}
                    onChange={hendleChangerole}
                    className="form-control bg-transparent"
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Product Sku</span>
                  </label>
                  <input
                    placeholder="Enter a sku"
                    name="sku"
                    value={productData?.sku || ""}
                    onChange={hendleChangerole}
                    className="form-control bg-transparent"
                  />
                </div>
              </div>

              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Is Product Type</span>
                  </label>
                  <select
                    className="form-control bg-transparent"
                    name="productType"
                    value={productData?.productType || ""}
                    onChange={hendleChangerole}
                  >
                    <option value="">Select Is Product Type</option>
                    <option value="Gram">Gram</option>
                    <option value="Piece">Piece</option>
                  </select>
                </div>
              </div>

              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Gst</span>
                  </label>
                  <input
                    placeholder="Enter a gst"
                    name="gst"
                    value={productData?.gst || ""}
                    onChange={hendleChangerole}
                    className="form-control bg-transparent"
                  />
                </div>
              </div>

              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">delivery charges</span>
                  </label>
                  <input
                    placeholder="Enter a delivery charges"
                    name="delivery_charges"
                    value={productData?.delivery_charges || ""}
                    onChange={hendleChangerole}
                    className="form-control bg-transparent"
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Select Brand</span>
                  </label>
                  <Select
                    value={selectedOptionbrand}
                    onChange={setSelectedOptionbrand}
                    options={branList}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Select Category</span>
                  </label>
                  <Select
                    value={selectedOptionPr}
                    onChange={hendletotest}
                    options={maincateList}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Select Sub Category</span>
                  </label>
                  <Select
                    value={selectedOption4}
                    onChange={setSelectedOption4}
                    options={subList4}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Select Sub Sub Category</span>
                  </label>
                  <Select
                    value={selectedOption}
                    onChange={setSelectedOption}
                    options={subList}
                  />
                </div>
              </div>

              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Video Type</span>
                  </label>
                  <select
                    className="form-select bg-transparent"
                    name="video_type"
                    value={productData?.video_type || ""}
                    onChange={hendleChangerole}
                  >
                    <option value={""}>Select Video Type</option>
                    <option value={"fullvideo"}> Full Video</option>
                    <option value={"shortvideo"}>Short Video</option>
                  </select>
                </div>
              </div>
              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Video Link</span>
                  </label>
                  <input
                    placeholder="Enter a video link"
                    name="video_link"
                    value={productData?.video_link || ""}
                    onChange={hendleChangerole}
                    className="form-control bg-transparent"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="prosection">
            <h3>Features </h3>
            {ferows.map((rowm, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <div className="row">
                  <div className="col-4">
                    <div className="fv-row mb-7">
                      <label className="fs-6 fw-semibold form-label mb-2">
                        <span className="required">Features Name</span>
                      </label>
                      <input
                        placeholder="Enter name"
                        value={rowm.name}
                        onChange={(e) =>
                          handlefrturechChange(
                            rowIndex,
                            "sizeIndex",
                            "name",
                            e.target.value,
                          )
                        }
                        className="form-control bg-transparent"
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="fv-row mb-7">
                      <label className="fs-6 fw-semibold form-label mb-2">
                        <span className="required">Features Value</span>
                      </label>
                      <input
                        placeholder="Enter value"
                        value={rowm.value}
                        onChange={(e) =>
                          handlefrturechChange(
                            rowIndex,
                            "sizeIndex",
                            "value",
                            e.target.value,
                          )
                        }
                        className="form-control bg-transparent"
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <label className="fs-6 fw-semibold form-label mb-2">
                      <span className="required">Action</span>
                    </label>
                    <br />
                    <div>
                      <button
                        className="btn btn-success"
                        onClick={() =>
                          setfeRows((prevRows) => [
                            ...prevRows,
                            { name: "", value: "" },
                          ])
                        }
                      >
                        Add New
                      </button>
                      {ferows?.length > 1 && (
                        <button
                          className="btn btn-danger ms-5"
                          onClick={() => removeFeatures(rowIndex)}
                        >
                          {" "}
                          Remove{" "}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <hr />
              </React.Fragment>
            ))}
          </div>

          <div className="prosection">
            <h3>Description </h3>
            <div className="row">
              <div className="col-12">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">Description</span>
                  </label>
                  <Cktest
                    aboutPage={aboutPage}
                    setaboutPage={setaboutPage}
                    uploadPlugin={uploadPlugin}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">seo title</span>
                  </label>
                  <input
                    placeholder="Enter a seo title"
                    name="seo_title"
                    value={productData?.seo_title || ""}
                    onChange={hendleChangerole}
                    className="form-control bg-transparent"
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="fv-row mb-7">
                  <label className="fs-6 fw-semibold form-label mb-2">
                    <span className="required">seo description</span>
                  </label>
                  <input
                    placeholder="Enter a seo description"
                    name="seo_description"
                    value={productData?.seo_description || ""}
                    onChange={hendleChangerole}
                    className="form-control bg-transparent"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="prosection">
            <h3>Variations</h3>
            {rows.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                {row.sizeProduct?.map((sizeProduct, sizeIndex) => (
                  <div key={sizeIndex}>
                    {sizeIndex === 0 && (
                      <div className="row">
                        <div className="col-4">
                          <div className="fv-row mb-7">
                            <label className="fs-6 fw-semibold form-label mb-2">
                              <span className="required">Color</span>
                            </label>
                            <select
                              value={row.color}
                              onChange={(e) =>
                                handleColorChange(
                                  rowIndex,
                                  sizeIndex,
                                  "color",
                                  e.target.value,
                                )
                              }
                              name="color"
                              className="form-control bg-transparent"
                            >
                              <option value="">Select Color</option>
                              {colorList &&
                                colorList?.map((datacolor2, i) => (
                                  <option
                                    key={i}
                                    value={datacolor2?.name}
                                    style={{ background: datacolor2?.name }}
                                  >
                                    {datacolor2?.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-4">
                          <ImageUploading
                            multiple
                            value={row?.images || []}
                            onChange={(imageList) =>
                              HendleImgFVer(imageList, rowIndex)
                            }
                            maxNumber={maxNumber}
                            dataURLKey="data_url"
                            acceptType={["png", "jpeg", "jpg", "webp"]}
                          >
                            {({ imageList, onImageUpload, onImageRemove }) => (
                              <div>
                                {imageList.map((image, imageIndex) => (
                                  <div
                                    key={imageIndex}
                                    className={"proadDImgContainer"}
                                  >
                                    <div className="image-item">
                                      <img
                                        width="100"
                                        src={image.data_url}
                                        alt={`Variant ${rowIndex + 1}`}
                                      />
                                    </div>
                                    <button
                                      className="proadDImgBtn btn btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary"
                                      onClick={() =>
                                        onRemoveImage(rowIndex, imageIndex)
                                      }
                                    >
                                      <i className="fas fa-trash-alt"></i>
                                      <DeleteOutlined />
                                    </button>
                                  </div>
                                ))}
                                <button
                                  className="btn btn-success mt-5"
                                  onClick={onImageUpload}
                                >
                                  Add Image
                                </button>
                              </div>
                            )}
                          </ImageUploading>
                        </div>
                      </div>
                    )}

                    <div className="row">
                      <div className="col-2">
                        <div className="fv-row mb-7">
                          <label className="fs-6 fw-semibold form-label mb-2">
                            <span className="required">
                              Size in{" "}
                              {productData?.productType == "Gram"
                                ? "Weight"
                                : "Piece"}
                            </span>
                          </label>
                          <input
                            type="number"
                            placeholder="Enter Size"
                            value={sizeProduct.size}
                            onChange={(e) =>
                              handleSizeChange(
                                rowIndex,
                                sizeIndex,
                                "size",
                                e.target.value,
                              )
                            }
                            className="form-control bg-transparent"
                          />
                        </div>
                      </div>

                      <div className="col-2">
                        <div className="fv-row mb-7">
                          <label className="fs-6 fw-semibold form-label mb-2">
                            <span className="required">price</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Enter price"
                            value={sizeProduct.price}
                            onChange={(e) =>
                              handleSizeChange(
                                rowIndex,
                                sizeIndex,
                                "price",
                                e.target.value,
                              )
                            }
                            className="form-control bg-transparent"
                          />
                        </div>
                      </div>

                      <div className="col-2">
                        <div className="fv-row mb-7">
                          <label className="fs-6 fw-semibold form-label mb-2">
                            <span className="required">stock</span>
                          </label>
                          <input
                            placeholder="Enter stock"
                            type="number"
                            value={sizeProduct.stock}
                            onChange={(e) =>
                              handleSizeChange(
                                rowIndex,
                                sizeIndex,
                                "stock",
                                e.target.value,
                              )
                            }
                            className="form-control bg-transparent"
                          />
                        </div>
                      </div>
                      <div className="col-2 mt-8">
                        {row.sizeProduct.length > 1 && (
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              removeSizeProduct(rowIndex, sizeIndex)
                            }
                          >
                            Remove Size
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

                <div className="row mt-3">
                  <div className="col-12">
                    <button
                      className="btn btn-success me-4"
                      onClick={() => addSizeProduct(rowIndex)}
                    >
                      {" "}
                      Add Size{" "}
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => removeColorProduct(rowIndex)}
                    >
                      {" "}
                      Remove Color Variant{" "}
                    </button>
                  </div>
                </div>
                <hr />
              </React.Fragment>
            ))}

            <div className="row mt-5">
              <div className="col-8">
                <button
                  className="btn btn-success"
                  onClick={() =>
                    setRows((prevRows) => [
                      ...prevRows,
                      {
                        color: "",
                        images: [],
                        sizeProduct: [
                          { size: "", sizetype: "", price: "", stock: "" },
                        ],
                      },
                    ])
                  }
                >
                  Add Color Row
                </button>
              </div>

              <div className="col-4 text-end">
                <button
                  disabled={btndis}
                  className="btn btn-primary px-10"
                  onClick={hendleTosubmit}
                >
                  {btndis ? "Updating..." : "Submit Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateProductCom;
